import { jsx as _jsx } from "react/jsx-runtime";
import ComparisonTableHeroV2Table from '../../comparison-table-hero-v2/ComparisonTableHeroV2Table/ComparisonTableHeroV2Table';
import { ComparisonTableHeroV2TableTrackingContextProvider } from '../../comparison-table-hero-v2/ComparisonTableHeroV2TrackingContext';
const ComparisonSelfServeBreakdown = ({ data, inverseHeader, trackEvent = () => {
    // do nothing
}, }) => {
    return (_jsx(ComparisonTableHeroV2TableTrackingContextProvider, Object.assign({ trackEvent: trackEvent, trackingData: {
            comparisonResponse: {},
            componentType: 'SelfServeBreakdown',
            excludePartners: true,
            midMarketRate: data.wise.exchangeRate,
        } }, { children: _jsx(ComparisonTableHeroV2Table, { showCheapestFlag: true, hideFooter: true, sendMoney: { currency: data.sourceCurrencyCode, value: data.sentAmount }, footerCTAType: "button", midMarketRate: data.wise.exchangeRate, inverseHeader: inverseHeader, quotes: [
                {
                    sourceCurrency: data.sourceCurrencyCode,
                    targetCurrency: data.targetCurrencyCode,
                    sendAmount: {
                        currency: data.sourceCurrencyCode,
                        value: data.sentAmount,
                    },
                    provider: {
                        name: 'Wise',
                        alias: 'wise',
                        logoUrl: 'https://wise.com/public-resources/assets/logos/wise-personal/logo.svg',
                        logoAltText: 'Wise',
                        partner: false,
                    },
                    rate: data.wise.exchangeRate,
                    fee: {
                        currency: data.sourceCurrencyCode,
                        value: data.wise.transferFees,
                    },
                    receivedAmount: {
                        value: data.wise.receivedAmount,
                        currency: data.targetCurrencyCode,
                    },
                    deliveryEstimation: {
                        providerGivesEstimate: false,
                        duration: null,
                    },
                },
                {
                    sourceCurrency: data.sourceCurrencyCode,
                    targetCurrency: data.targetCurrencyCode,
                    sendAmount: {
                        currency: data.sourceCurrencyCode,
                        value: data.sentAmount,
                    },
                    provider: {
                        name: 'Competitor',
                        alias: 'competitor',
                        logoUrl: '',
                        logoAltText: 'Competitor',
                        partner: false,
                    },
                    rate: data.competitor.exchangeRate || null,
                    fee: null,
                    receivedAmount: {
                        value: data.competitor.receivedAmount,
                        currency: data.targetCurrencyCode,
                    },
                    deliveryEstimation: {
                        providerGivesEstimate: false,
                        duration: null,
                    },
                    disableAdditionalInfo: !data.competitor.exchangeRate,
                },
            ] }) })));
};
export default ComparisonSelfServeBreakdown;
